"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readonly = exports.createDeepProxy = void 0;
function createDeepProxy(handler, options) {
    const r2p = new WeakMap();
    const p2r = new WeakMap();
    const xGet = handler.get || Reflect.get.bind(Reflect);
    const xSet = handler.set || Reflect.set.bind(Reflect);
    const xDefineProperty = handler.defineProperty || Reflect.defineProperty.bind(Reflect);
    const ignoreKey = options === null || options === void 0 ? void 0 : options.ignoreKey;
    const mixedHandler = {
        ...handler,
        get(target, p, recv) {
            let ans = xGet(target, p, recv);
            if (!ignoreKey || !ignoreKey(p))
                ans = toProxy(ans);
            return ans;
        },
        set(target, p, value, recv) {
            return xSet(target, p, toRaw(value), recv);
        },
        defineProperty(target, p, attributes) {
            if (attributes.value)
                attributes = { ...attributes, value: toRaw(attributes.value) };
            return xDefineProperty(target, p, attributes);
        },
    };
    const toRaw = (value) => ((typeof value === 'object' && value && p2r.has(value)) ? p2r.get(value) : value);
    const toProxy = (input) => {
        if (!input || typeof input !== 'object')
            return input;
        if (p2r.has(input))
            return input;
        if (r2p.has(input))
            return r2p.get(input);
        const proxied = new Proxy(input, mixedHandler);
        r2p.set(input, proxied);
        p2r.set(proxied, input);
        return proxied;
    };
    toProxy.toRaw = toRaw;
    toProxy.isProxy = (value) => p2r.has(value);
    return toProxy;
}
exports.createDeepProxy = createDeepProxy;
/**
 * proxy a data. all its content is readonly
 */
exports.readonly = createDeepProxy({
    set() {
        throw new Error('Cannot invoke set on readonly object');
    },
    deleteProperty() {
        throw new Error('Cannot invoke deleteProperty on readonly object');
    },
    defineProperty() {
        throw new Error('Cannot invoke defineProperty on readonly object');
    },
    preventExtensions() {
        return false;
    },
});
//# sourceMappingURL=proxy.js.map